var map = {
	".": 3260,
	"./": 3260,
	"./imgs/01.png": 7870,
	"./imgs/02.png": 6952,
	"./imgs/03.png": 2031,
	"./imgs/04.png": 5075,
	"./imgs/05.png": 4729,
	"./imgs/06.png": 5510,
	"./imgs/07.png": 1511,
	"./imgs/08.png": 5940,
	"./imgs/09.png": 5985,
	"./imgs/10.png": 4767,
	"./imgs/zan.png": 105,
	"./index": 3260,
	"./index.tsx": 3260,
	"./style.scss": 1778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7850;